const LK_CheckboxChecked =({color,width,height})=>{  
    return(
        <svg width={width} height={height} viewBox="0 0 15 15" fill={color} xmlns="http://www.w3.org/2000/svg">
            <path d="M1.5223 0C0.682751 0 0 0.7475 0 1.66667V13.3333C0 14.2525 0.682751 15 1.5223 15H12.1784C13.0179 15 13.7007 14.2525 13.7007 13.3333V5.20182L12.1784 6.86849L12.1799 13.3333H1.5223V1.66667H10.4718L11.9941 0H1.5223ZM13.9237 0.244141L6.0892 8.82162L3.58276 6.07747L2.50644 7.25586L6.0892 11.1784L15 1.42253L13.9237 0.244141Z" fill={color}/>
        </svg>
    );
};

export default LK_CheckboxChecked;